import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ElasticSearchResult } from 'app/interfaces/elastic-search-result.model';
import { ElasticQuery } from 'app/interfaces/elastic-query.model';
import { QueryType } from 'app/enums/query-type.enum';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable()
export class SearchService {
  constructor(private _http: HttpClient) {}

  find(size: number = 12, from: number = 0, filters: Array<ElasticQuery>): Observable<ElasticSearchResult> {
    if (!filters) {
      filters = [
        {
          Type: QueryType.MATCHALL,
          Field: null,
          Values: null,
        },
      ];
    }

    return this._http.post<any>(`${environment.apiUrl}projects/find?size=${size}&from=${from}`, filters, { withCredentials: true });
  }

  getDetails(size: number = 12, from: number = 0, filters: Array<ElasticQuery>): Observable<ElasticSearchResult> {
    if (!filters) {
      filters = [
        {
          Type: QueryType.MATCHALL,
          Field: null,
          Values: null,
        },
      ];
    }
    return this._http.post<any>(`${environment.apiUrl}details/find?size=${size}&from=${from}`, filters);
  }

  getAggregations() {
    return this._http.get<any>(`${environment.apiUrl}projects/aggregations`);
  }
}
